import backend from 'utils/backend';

// Pairs a job reader with the route its cards link to and the card behaviour that goes with
// it, so the Loom sandbox is a different value for one prop rather than a second set of
// components. Only the Loom cards name an unregistered poster, and only Loom's list endpoint
// can filter by job kind; /career keeps its existing wording and its single status filter.
// CQ-375 deletes the LOOM entry and its routes, and keeps the reader.
const JOB_SOURCES = {
  LEGACY: {
    api: () => backend.career,
    detailPath: '/career',
    showUnregisteredPoster: false,
    supportsJobTypeFilter: false,
    showJobTypePill: false,
    canGenerate: false,
  },
  LOOM: {
    api: () => backend.loom.career,
    detailPath: '/career/loom',
    showUnregisteredPoster: true,
    supportsJobTypeFilter: true,
    showJobTypePill: true,
    canGenerate: true,
  },
};

export default JOB_SOURCES;
